// configure-amplify MUST be imported before any module that calls generateClient()
import "./configure-amplify";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import "@aws-amplify/ui-react/styles.css";
import { AdminAppProvider } from "./presentation/AdminAppProvider";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AdminAppProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AdminAppProvider>
  </React.StrictMode>,
);
